import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { renderClose } from "../../common/dialog";
import { useState } from "react";
import { CustomerDto, OrderCycleDto, OrderCycleEditDto, OrderCyclesDto, RetentionSaveDto } from "./types";
import { createEntityStore, UseEntityStore } from "../../common/entityStore";
import { propBoolField, propDateField, propNumberField, propTextField } from "../../common/entityStoreForm";
import { propInt, propNumber, propRequired, propValidValue, propValueValidator } from "../../common/entityStoreValidators";
import { customerOrderDialogTitle, useCustomerBasicInfo } from "./common";

export const OrderCycleDialog = (props: {
    close: () => void;
    useCustomerStore: UseEntityStore<CustomerDto>;
    ordId: number;
    orderId: number;
    orderCycle: OrderCycleDto;
    useOrderCyclesStore: UseEntityStore<OrderCyclesDto>;
    onOrderCycleSaved(): void;
    retention?: RetentionSaveDto;
    clearRetention(): void;
}) => {
    const { actualCycle } = props.useOrderCyclesStore(p => ({ actualCycle: p.clientData.actualCycle }))
    const disabled = props.orderCycle.cycleId < actualCycle;
    const customer = useCustomerBasicInfo(props.useCustomerStore);
    const [{ useOrderCycleStore }] = useState(() => {
        const useOrderCycleStore = createEntityStore<OrderCycleEditDto>({
            data: { ...props.orderCycle, orderId: props.orderId, retention: props.retention }, path: "customers/orderCycles", fetchOnInit: false,
            saveProps: ["orderId", "cycleId", "cycQty", "skipCyc", "gift", "freeShp", "endCyc", "retention"], onSaved(data) {
                if (data.retention == null) {
                    props.clearRetention();
                    useOrderCycleStore.getState().setClientDataProp("retention", null);
                }
                props.onOrderCycleSaved();
                props.close();
            },
            propValidators: [
                propValidValue("cycQty", "cycQtyFormatted"),
                propRequired("cycQty"),
                propInt("cycQty"),
                propNumber("cycQty", p => p <= 0 && "Cycle quantity must be > 0."),
                propNumber("cycQty", p => p > props.useOrderCyclesStore.getState().clientData.maxShipmentUnit &&
                    `Maximum ${props.useOrderCyclesStore.getState().clientData.maxShipmentUnit} packs allowed.`),
                propValueValidator("endCyc", (v, e) => {
                    const otherEndCyc = props.useOrderCyclesStore.getState().clientData.cycles.find(p => p.cycleId !== e.cycleId && !p.closedCyc && p.endCyc);
                    return v === true && otherEndCyc != null && `End cycle is already set on cycle ${otherEndCyc.cycleId}.`;
                }),
                propValueValidator("gift", (v, e) => v === true && (e.artId == null || e.artId === "") && `Free GIFT is not available for this project.`),
            ]
        });
        return { useOrderCycleStore };
    });
    const { save, isSaveDisabled } = useOrderCycleStore(p => ({ save: p.save, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{customerOrderDialogTitle(props.ordId, false, () => "Edit cycle " + props.orderCycle.cycleId, customer)}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2}>
                <Grid item xs={6}>{propTextField(props.useOrderCyclesStore)("product", "Product", { disabled: true })}</Grid>
                <Grid item xs={6}>{propTextField(props.useOrderCyclesStore)("project", "Project", { disabled: true })}</Grid>
                <Grid item xs={6}>{propNumberField(useOrderCycleStore)("cycleId", null, "Cycle", { disabled: true })}</Grid>
                <Grid item xs={6}>{propDateField(useOrderCycleStore)("startDate", null, "Cycle start date", { disabled: true })}</Grid>
                <Grid item xs={6}>{propNumberField(useOrderCycleStore)("cycQty", "cycQtyFormatted", "Quantity", { disabled })}</Grid>
                <Grid item xs={6}>{propBoolField(useOrderCycleStore)("endCyc", "End cycle?", { disabled })}</Grid>
                <Grid item xs={6}>{propBoolField(useOrderCycleStore)("skipCyc", "Skip cycle?", { disabled })}</Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={6}>{propBoolField(useOrderCycleStore)("freeShp", "Free ship?", { disabled })}</Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={6}>{propBoolField(useOrderCycleStore)("gift", "Free GIFT?", { disabled })}</Grid>
                <Grid item xs={6}>{propTextField(useOrderCycleStore)("artId", "Free GIFT article", { disabled: true })}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button disabled={isSaveDisabled || disabled} onClick={save} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};
